import { TipoDespachoEnum } from "./Dte/TipoDespacho.enum";

export class GuiaDespacho {
   guiaDespachoId: string;
   facturableId: string;
   dteId: string;
   tipoTraslado: number;
   tipoDespacho: TipoDespachoEnum;
   rutTransporte: number;
   patente: string;
   patenteCarro?: string;
   rutChofer: number;
   dvChofer: string;
   dvTransporte: string;
   nombreChofer: string;
   dirDest?: string;
   cmnaDest?: string;
   fechaSalida?: string;
   horaSalida?: string;
   fechaLlegada?: string;
   nombreTipoTraslado: string;
   nombreTipoDespacho: string;
   anulado: boolean;
}
